import React, {useCallback, useState} from 'react';

import {PermissionIntentFilter} from 'graphql-client/__generated/graphqlGlobalTypes';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import type {
  TemplateCollectionSelectorQuery,
  TemplateCollectionSelectorQueryVariables,
} from 'notebook/entry-templates/collections/__generated/TemplateCollectionSelectorQuery';
import {TEMPLATE_COLLECTION_SELECTOR_QUERY} from 'notebook/entry-templates/collections/TemplateCollectionSelector';
import SaveAsTemplateModal from 'notebook/entry-templates/SaveAsTemplateModal';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface SaveAsTemplateButtonProps {
  fileId: string;
}

export default function SaveAsTemplateButton({fileId}: SaveAsTemplateButtonProps): JSX.Element | null {
  const [modalOpened, setModalOpened] = useState(false);
  const openModal = useCallback(() => {
    setModalOpened(true);
  }, []);

  const result = useBenchlingQuery<TemplateCollectionSelectorQuery, TemplateCollectionSelectorQueryVariables>(
    TEMPLATE_COLLECTION_SELECTOR_QUERY,
    {
      variables: {
        searchInput: {permissionsLevel: PermissionIntentFilter.WRITE},
        limitOffsetInput: {limit: 1, offset: 0},
      },
    }
  );

  const hasWritableCollections =
    result.type === QueryResultType.SUCCESS && result.data.templateCollectionsListing.collections.length > 0;

  return hasWritableCollections ? (
    <>
      <Row>
        <Col md={12}>
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            fullWidth={true}
            onClick={openModal}
            size={ButtonSize.SMALL}
            text="Save as template"
            dataTestAttrs={{component: 'InformationSubpanel', element: 'saveAsTemplateButton'}}
          />
        </Col>
      </Row>
      <SaveAsTemplateModal
        sourceId={fileId}
        opened={modalOpened}
        onClose={() => {
          setModalOpened(false);
        }}
      />
    </>
  ) : null;
}
